import BlogPost from "../components/BlogPost";
import MainBlog from "../components/MainBlog";
import { libraryMainBlog, yogaMainBlog } from "../data/data";
import NonStickyNavAndFooter from "./layout/NonStickyNavAndFooter";

export default function BlogPage() {
    return (
        <NonStickyNavAndFooter>
            <MainBlog />
            <br />
            <BlogPost post={libraryMainBlog} title="Library"  id="library"/>
            <br />
            <BlogPost post={yogaMainBlog} title="Yoga"  id="yoga"/>
        </NonStickyNavAndFooter>
    )
}

